import { c as _c } from "react/compiler-runtime";
import { useMemo, useCallback } from 'react';
import avo from 'analytics/avo';
import usePDPContext from 'components/consumer/PDP/state/context/usePDPContext';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import usePDPPrice from 'data-hooks/usePDPPrice';
const usePDPWishlistEvents = () => {
  const $ = _c(22);
  const pdpContext = usePDPContext();
  const {
    data: priceData
  } = usePDPPrice();
  const clearanceData = usePDPClearanceData();
  pdpContext?.productOptions?.data;
  const selectedOptionsExtended = pdpContext?.productOptions?.data?.selectedOptionsExtended;
  let t0;
  if ($[0] !== selectedOptionsExtended) {
    t0 = selectedOptionsExtended ? Object.keys(selectedOptionsExtended).reduce((accu, element) => {
      const selectedOptionLabel = selectedOptionsExtended[element]?.value?.value;
      return selectedOptionLabel ? [...accu, selectedOptionLabel] : accu;
    }, []).filter(Boolean).join(",") : "";
    $[0] = selectedOptionsExtended;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const productVariantDetails = t0;
  let t1;
  if ($[2] !== clearanceData || $[3] !== pdpContext?.basicDetails?.data || $[4] !== pdpContext?.productOptions?.data || $[5] !== priceData?.price?.final_price || $[6] !== priceData?.price?.original_price || $[7] !== priceData?.productOptions?.data?.stock?.isSelectedOptionsQuickship || $[8] !== productVariantDetails) {
    t1 = () => {
      const product = pdpContext?.basicDetails?.data;
      const productOptionData = pdpContext?.productOptions?.data;
      avo.productAddedToWishlist({
        productId: product?.id,
        fabricId: 0,
        fabricName: "",
        price: priceData?.price?.final_price ? parseFloat(priceData?.price?.final_price) : 0,
        productFamily: product?.family?.name || "",
        sku: productOptionData?.selectedOptionsVariantSku,
        fabricColor: "",
        fullPrice: priceData?.price?.original_price ? parseFloat(priceData?.price?.original_price) : 0,
        isClearance: !!clearanceData.isClearance,
        quickship: !!priceData?.productOptions?.data?.stock?.isSelectedOptionsQuickship,
        location: avo.Location.PDP,
        name: product?.name,
        variant: productVariantDetails,
        category: product?.type?.name,
        currency: "USD"
      });
    };
    $[2] = clearanceData;
    $[3] = pdpContext?.basicDetails?.data;
    $[4] = pdpContext?.productOptions?.data;
    $[5] = priceData?.price?.final_price;
    $[6] = priceData?.price?.original_price;
    $[7] = priceData?.productOptions?.data?.stock?.isSelectedOptionsQuickship;
    $[8] = productVariantDetails;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const productAddedToWishlistEvent = t1;
  let t2;
  if ($[10] !== clearanceData || $[11] !== pdpContext?.basicDetails?.data || $[12] !== pdpContext?.productOptions?.data || $[13] !== priceData?.price?.final_price || $[14] !== priceData?.price?.original_price || $[15] !== productVariantDetails) {
    t2 = () => {
      const product_0 = pdpContext?.basicDetails?.data;
      const productOptionData_0 = pdpContext?.productOptions?.data;
      avo.productRemovedFromWishlist({
        productId: product_0?.id,
        category: product_0?.type?.name,
        isClearance: !!clearanceData.isClearance,
        name: product_0?.name,
        price: priceData?.price?.final_price ? parseFloat(priceData?.price?.final_price) : 0,
        quantity: 1,
        sku: productOptionData_0?.selectedOptionsVariantSku,
        variant: productVariantDetails,
        fullPrice: priceData?.price?.original_price ? parseFloat(priceData?.price?.original_price) : 0,
        productFamily: product_0?.family?.name || "",
        contentIds: [product_0?.sku],
        isFlashSale: !!clearanceData.isFlashSale,
        currency: "USD"
      });
    };
    $[10] = clearanceData;
    $[11] = pdpContext?.basicDetails?.data;
    $[12] = pdpContext?.productOptions?.data;
    $[13] = priceData?.price?.final_price;
    $[14] = priceData?.price?.original_price;
    $[15] = productVariantDetails;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const productRemovedFromWishlistEvent = t2;
  let t3;
  if ($[17] !== productAddedToWishlistEvent || $[18] !== productRemovedFromWishlistEvent) {
    t3 = isFavorited => {
      if (!isFavorited) {
        productAddedToWishlistEvent();
      } else {
        productRemovedFromWishlistEvent();
      }
    };
    $[17] = productAddedToWishlistEvent;
    $[18] = productRemovedFromWishlistEvent;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const productWishlistEvent = t3;
  let t4;
  if ($[20] !== productWishlistEvent) {
    t4 = {
      productWishlistEvent
    };
    $[20] = productWishlistEvent;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};
export default usePDPWishlistEvents;